import React from 'react';
import {
  PRICING_PLANS_GRID_CLASS,
  PRICING_PLANS_GRID_TEST_ID,
  sortPlanEntries,
} from '../../lib/pricingPlanDisplay';
import PricingPlanCard from './PricingPlanCard';

export default function PricingPlansGrid({
  packages,
  locale,
  billingCycle,
  currentPlanId,
  featureLabels,
  getPlanButtonLabel,
  onSelectPlan,
  paymentsEnabled,
  t,
}) {
  const plans = sortPlanEntries(packages);

  return (
    <section
      className="mx-auto w-full max-w-7xl overflow-x-hidden px-4 pb-12"
      data-testid={PRICING_PLANS_GRID_TEST_ID}
    >
      <div className={PRICING_PLANS_GRID_CLASS}>
        {plans.map(([planId, rawPackage]) => {
          const isCurrentPlan = currentPlanId === planId;
          return (
            <PricingPlanCard
              key={planId}
              planId={planId}
              rawPackage={rawPackage}
              locale={locale}
              billingCycle={billingCycle}
              isCurrentPlan={isCurrentPlan}
              featureLabels={featureLabels}
              buttonLabel={getPlanButtonLabel(rawPackage, isCurrentPlan)}
              onSelectPlan={onSelectPlan}
              paymentsEnabled={paymentsEnabled}
              t={t}
            />
          );
        })}
      </div>
    </section>
  );
}
